export default "__VITE_ASSET__CucOooFK__"